import React from 'react';
import PropTypes from 'prop-types';
import { withTheme } from 'styled-components';

// Images
import {
  AutoCollect,
  Bass,
  Burger,
  BurgerClose,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  Copy,
  CrossBorder,
  Csv,
  Delete,
  Developers,
  Download,
  Ellipsis,
  Info,
  Logout,
  Payout,
  Pencil,
  Pg,
  Profile,
  Refresh,
  Send,
  Settings,
  Settlements,
  StatusPage,
  Stop,
  Subscriptions,
  Switch,
  Test,
  TickOutline,
  TopRightArrow,
  VerificationSuite,
  Xls,
  Aadhaar,
  Bav,
  Upi,
  Pan,
  SecureIdentityVerification,
  Cashfree,
  MobileKeypad,
  NavigateRight,
  Reset,
  NewImages,
  AadhaarOCR,
  PanOCR,
  PlusEdge,
  PrimaryPlus,
  Condition,
  Mobile,
  CircularChevronLeft,
  CircularChevronRight,
  ApiTwoTone,
  SendKycForm,
  CreateNew,
  EmployeeOnboarding,
  LendingUser,
  Undo,
  Redo,
  APIKey,
  Thunder,
  Share,
  Certified,
  Vault,
  CashfreeLogo,
} from '../CustomIcons';

const map = {
  'auto-collect': AutoCollect,
  baas: Bass,
  burger: Burger,
  'burger-close': BurgerClose,
  'chevron-down': ChevronDown,
  'chevron-left': ChevronLeft,
  'chevron-right': ChevronRight,
  'chevron-up': ChevronUp,
  copy: Copy,
  crossborder: CrossBorder,
  csv: Csv,
  delete: Delete,
  developers: Developers,
  download: Download,
  ellipsis: Ellipsis,
  info: Info,
  logout: Logout,
  payout: Payout,
  pencil: Pencil,
  pg: Pg,
  profile: Profile,
  refresh: Refresh,
  send: Send,
  settings: Settings,
  settlements: Settlements,
  'status-page': StatusPage,
  stop: Stop,
  subscriptions: Subscriptions,
  switch: Switch,
  test: Test,
  'tick-outline': TickOutline,
  'top-right-arrow': TopRightArrow,
  'verification-suite': VerificationSuite,
  xls: Xls,
  Aadhaar,
  BAV: Bav,
  UPI: Upi,
  PAN: Pan,
  AADHAAR_OCR: AadhaarOCR,
  PAN_OCR: PanOCR,
  SecureIdentityVerification,
  Cashfree,
  MobileKeypad,
  'navigate-right': NavigateRight,
  reset: Reset,
  'plus-edge': PlusEdge,
  'primary-plus': PrimaryPlus,
  condition: Condition,
  mobile: Mobile,
  'circular-left': CircularChevronLeft,
  'circular-right': CircularChevronRight,
  'send-kyc-forms': SendKycForm,
  'api-twotone': ApiTwoTone,
  'create-new': CreateNew,
  'employee-onboarding': EmployeeOnboarding,
  others: LendingUser,
  undo: Undo,
  redo: Redo,
  APIKey,
  Thunder,
  Share,
  Certified,
  vault: Vault,
  'cashfree-logo': CashfreeLogo,
  ...NewImages,
};

const Icon = ({ name, verticalAlign = 'middle', ...props }) => {
  const Component = map[name];

  return <Component style={{ verticalAlign }} {...props} />;
};

Icon.propTypes = {
  name: PropTypes.string.isRequired,
  theme: PropTypes.object,
  fill: PropTypes.string,
  verticalAlign: PropTypes.oneOf(['bottom', 'middle', 'top']),
};

export default withTheme(Icon);
